




import { useState } from 'react';
import { motion } from 'framer-motion';
import { Mail, Smartphone, ArrowRight } from 'lucide-react';

const LoginStepOne = ({ onSubmit, onForgotPassword }) => {
  const [value, setValue] = useState('');
  const [error, setError] = useState('');

  // Detect email or mobile
  const detectType = (input) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const mobileRegex = /^[\d\s\-\+\(\)]+$/;
    if (emailRegex.test(input)) return 'email';
    const cleanMobile = input.replace(/[\s\-\(\)]/g, '');
    if (mobileRegex.test(cleanMobile) && cleanMobile.length >= 10) return 'mobile';
    return null;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (!value.trim()) {
      setError('Please enter your email or mobile number');
      return;
    }

    const type = detectType(value);
    if (!type) {
      setError('Please enter a valid email or mobile number');
      return;
    }

    onSubmit(value, type);
  };

  const inputType = value ? detectType(value) : null;

  return (
    <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '24px', width: '100%', maxWidth: '400px', margin: '0 auto', }}>
      {/* Input Field */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', position: 'relative' }}>
        <label style={{ fontSize: '0.875rem', fontWeight: 500, color: '#111827' }}>Email or Mobile Number</label>
        <div style={{ position: 'relative' }}>
          {/* Icon based on input type */}
          <div style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#6B7280', }}>
            {inputType === 'email' ? (
              <Mail style={{ width: '20px', height: '20px', color: '#8B5CF6' }} />
            ) : inputType === 'mobile' ? (
              <Smartphone style={{ width: '20px', height: '20px', color: '#EC4899' }} />
            ) : (
              <Mail style={{ width: '20px', height: '20px', color: '#9CA3AF' }} />
            )}
          </div>

          {/* Input field */}
          <input
            type="text"
            value={value}
            onChange={(e) => {
              setValue(e.target.value);
              setError('');
            }}
            // placeholder="Enter email or mobile number"
            placeholder="Enter email ID"
            style={{
              width: '100%',
              padding: '12px 16px 12px 44px',
              borderRadius: '12px',
              border: `2px solid ${error ? '#EF4444' : '#D1D5DB'}`,
              background: 'rgba(243, 244, 246, 0.5)',
              fontSize: '1rem',
              outline: 'none',
              transition: 'all 0.3s',
            }}
          />
        </div>

        {/* Error message */}
        {error && (
          <motion.p
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            style={{ fontSize: '0.875rem', color: '#EF4444' }}
          >
            {error}
          </motion.p>
        )}

        {/* Success detection message */}
        {inputType && !error && (
          <motion.p
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            style={{ fontSize: '0.875rem', color: inputType === 'email' ? '#8B5CF6' : '#EC4899' }}
          >
            {inputType === 'email' ? '✓ Email detected' : '✓ Mobile number detected'}
          </motion.p>
        )}
      </div>



      {/* Continue Button */}
      <motion.button
        type="submit"
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        style={{
          width: '100%', padding: '12px', background: 'linear-gradient(to right, #8B5CF6, #EC4899)', color: '#fff', borderRadius: '12px', fontWeight: 600, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
          cursor: 'pointer', border: 'none', boxShadow: '0 4px 12px rgba(139, 92, 246, 0.3)',
        }}>
        Continue <ArrowRight style={{ width: '20px', height: '20px' }} />
      </motion.button>

      {/* Forgot Password Button */}
      {onForgotPassword && (
        <button type="button" onClick={onForgotPassword} style={{ marginTop: 12, background: 'none', border: 'none', color: '#6366f1', fontSize: 14, cursor: 'pointer', alignSelf: 'flex-start', }}>
          Forgot Password?
        </button>
      )}

      {/* Divider */}
      <div style={{ position: 'relative', textAlign: 'center', margin: '16px 0' }}>
        <div style={{ position: 'absolute', top: '50%', left: 0, width: '100%', borderTop: '1px solid #D1D5DB', transform: 'translateY(-50%)', }} />
        <span style={{ position: 'relative', background: '#fff', padding: '0 8px', color: '#6B7280', fontSize: '0.875rem', }}>Or continue with</span>
      </div>


    </form>
  );
};

export default LoginStepOne;
